import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OmsComponent } from './oms.component';
import { OmsListComponent } from './oms-list/oms-list.component';
import { CustomerAuthGaurd } from '../../auth/auth.guard';
import { OmsReturnComponent } from './oms-return/oms-return.component';
import { OmsDetailsComponent } from './oms-details/oms-details.component';
import { OrderInprogressDetailsComponent } from './order-inprogress-details/order-inprogress-details.component';

const routes: Routes = [
  {
    path: '',
    component: OmsComponent,
    children: [
      {
        path: 'orders',
        component: OmsListComponent,
        data: { menuName: 'customer rfq screen' },
        canActivate: [CustomerAuthGaurd],
      },
      {
        path: 'ordersInProgress/:id',
        component: OrderInprogressDetailsComponent,
        data: { menuName: 'customer rfq screen' },
        canActivate: [CustomerAuthGaurd],
      },
      {
        path: 'orders/:id',
        component: OmsDetailsComponent,
        data: { menuName: 'customer rfq screen', type: 'parent' },
      },
      {
        path: 'orders/:id/return',
        component: OmsReturnComponent,
        data: { menuName: 'customer rfq screen', type: 'parent' },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OmsRoutingModule {}
